/* eslint-disable */
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default {
  state: {
    getCourseAuthorsState: {},
    createCourseAuthorsState:{},
    createAuthorUsersState:{},
    getAuthorDetailsByIDState:{}
  },
  mutations: {
    getCourseAuthorsMutation(state, response) {
      state.getCourseAuthorsState = response;
    },
    createCourseAuthorsMutation(state, response) {
      state.createCourseAuthorsState = response;
    },
    createAuthorUsersMutation(state, response){
      state.createAuthorUsersState = response;
    },
    getAuthorDetailsByIDMutation(state, response){
      state.getAuthorDetailsByIDState = response;
    }
  },
  actions: {
    // Get Course Auhtors List
    getCourseAuthorListFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/course-author/admin/').then((response) => {
          context.commit('getCourseAuthorsMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Get User Auhtors BY ID List
    getAuthorDetailsByIDFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/course-author/admin/'  + payload.id + '/').then((response) => {
          context.commit('getAuthorDetailsByIDMutation', response.data);
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Assign Course To Auhtors BY List
    createAuthorUsersFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/course-author/admin/', payload).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Assign Course To Auhtors BY List
    assingCourseToAuthorFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/course-author/admin/course-assign/', payload).then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Remove Course Auhtors List
    removeUserAuthorFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/course-author/admin/' + payload.id + '/').then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
    // Remove Assigned Course Auhtors List
    removeAssignedCourseAuthorFun(context, payload) {
      return new Promise((resolve, reject) => {
        axios.delete('/course-author/admin/' + payload.data.AuthorId + '/course/' + payload.data.CourseId + '/').then((response) => {
          resolve(response);
        })
          .catch(function (error) {
            reject(error);
          });
      })
    },
  },
  getters: {
    getCourseAuthorsGetter: state => state.getCourseAuthorsState,
    createCourseAuthorsGetter: state => state.createCourseAuthorsState,
    createAuthorUsersGetter: state => state.createAuthorUsersState,
    getAuthorDetailsByIDGetter: state => state.getAuthorDetailsByIDState
  }
}